/* eslint semi:0 */
import { registerUtils, } from 'application/nm'
import { create as makeEmptyObj, } from 'utils/object'

function filter(iterable, predicateFn){
  return [...iterable].filter(predicateFn)
}

function makeSet(iterable){
  return new Set(iterable)
}

// based on http://www.2ality.com/2015/01/es6-set-operations.html
const set = Object.assign(makeEmptyObj(), {

  union(...iterables){
    return makeSet(
      iterables.reduce(
        (acc, iterable) => [...acc, ...iterable, ],
        []
      )
    )
  },

  filter,

  intersection(...iterables){
    return iterables.reduce(
      (acc, iterable) => makeSet(filter(iterable, m => acc.has(m))),
      makeSet(iterables[0])
    )
  },
  
})

registerUtils({ set, })

export default set


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/utils/set.js